"use client"

import React from "react";

export default function ErrorPage() {
    return(
        <React.Fragment>
        </React.Fragment>
    )
}